import { useState } from "react";
import { Dialog, DialogBackdrop } from "reakit";
import clsx from "clsx";
import styles from "./BannerModal.module.scss";
import { Icon } from "../SVGsprite/svgsprite";
import { Loader } from "../Loader/Loader";
import { useActor, useMachine } from "@xstate/react";
import { userCardMachine } from "../../xstate/userCard.machine";
import { AuthState } from "../../xstate/auth.machine";

export function DistVerifyBanner(props) {
	const [isUserAnswerNo, setIsUserAnswerNo] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [stateUserCard, sendUserCard] = useMachine(userCardMachine);
	const [stateAuth, sendAuth] = useActor(AuthState);

	const handleYesAnswer = async () => {
		setIsLoading(true);
		const formData = new FormData();
		formData.append("service_order_verification_status", "enabled");
		try {
			sendUserCard({
				type: "updateUser",
				data: formData,
			});
			sendAuth({
				type: "updateServiceOrderVerificationStatus",
				data: { service_order_verification_status: "enabled" },
			});
		} catch (e) {
			console.log(e);
		} finally {
			if (props?.onClose) props.onClose();
			props.dialog.hide();
			if (props.onNavigateToProfile) {
				props.onNavigateToProfile();
			}
			setIsLoading(false);
		}

		// try {
		// const response = await apiMethods.myInfo.updateDistributorVerify({
		// 	isVerifyDistributor: true,
		// });
		// if (response.status === 200) {
		// 	// Обновляем локальный state через xstate
		// 	send({
		// 		type: "updateDistributorVerify",
		// 		data: { isVerifyDistributor: true },
		// 	});
		// 	if (props?.onClose) props.onClose();
		// 	props.dialog.hide();
		// }
		// } catch (error) {
		// 	console.error("Ошибка при включении верификации:", error);
		// } finally {
		// 	setIsLoading(false);
		// }
	};

	const handleNoAnswer = () => {
		const formData = new FormData();
		formData.append("service_order_verification_status", "disabled");
		try {
			sendUserCard({
				type: "updateUser",
				data: formData,
			});
			sendAuth({
				type: "updateServiceOrderVerificationStatus",
				data: { service_order_verification_status: "disabled" },
			});
		} catch (e) {
			console.log(e);
		} finally {
			setIsLoading(false);
		}
		setIsUserAnswerNo(true);
	};

	const handleGoToProfile = () => {
		if (props?.onClose) props.onClose();
		props.dialog.hide();
		if (props.onNavigateToProfile) {
			props.onNavigateToProfile();
		}
		setTimeout(() => {
			setIsUserAnswerNo(false);
		}, 400);
	};

	return (
		<DialogBackdrop
			{...props.dialog}
			className={"backdrop disabled_blur " + styles.mainModal}
		>
			<Dialog
				{...props.dialog}
				aria-label={
					isUserAnswerNo ? "Спасибо за ответ!" : "Верификация заказ-нарядов"
				}
				className={clsx("modal", styles.bannerModal)}
				hideOnClickOutside={false}
				hideOnEsc={false}
			>
				<div className={clsx("modalBody", styles.bannerBody)}>
					{!isUserAnswerNo ? (
						<>
							<h2 className={styles.title}>Верификация заказ-нарядов</h2>
							<p className={styles.description}>
								Мы добавили возможность проверять заказ-наряды. Продавцы
								загружают, а вы проверяете.
								<br /> Готовы включить верификацию?
							</p>
							<div className={styles.button_block}>
								<div
									onClick={handleYesAnswer}
									className="btn btnPrimary"
									disabled={isLoading}
								>
									{isLoading ? <Loader /> : "Да, включить"}
								</div>
								<div
									onClick={handleNoAnswer}
									className="btn btnPrimary"
									disabled={isLoading}
								>
									Позже
								</div>
							</div>
						</>
					) : (
						<>
							<h2 className={styles.title}>Спасибо за ответ!</h2>
							<p className={styles.description}>
								Верификацию заказ-нарядов можно включить
								<br /> в настройках профиля.
							</p>
							<div className={styles.button_block}>
								<div onClick={handleGoToProfile} className="btn btnPrimary">
									Перейти в профиль
								</div>
							</div>
						</>
					)}
				</div>
			</Dialog>
		</DialogBackdrop>
	);
}
